import { createSlice } from '@reduxjs/toolkit';
import { parseISO, startOfTomorrow, startOfYesterday } from 'date-fns';
import * as R from 'ramda';
import { fetchSearchPTOs } from './searchOrder';
import { fetchOriginators } from './originators';
import { fetchRecipients } from './recipients';
import { fetchLocations } from './locations';
import { fetchPtoNumbers } from './orderNumbers';
import { fetchReferenceIds } from './referenceIds';
import { fetchProducts } from './products';

const initialState = {
  fromDate: startOfYesterday().toJSON(),
  location: '',
  originator: '',
  product: '',
  ptoNumber: '',
  recipient: '',
  referenceId: '',
  status: 'all',
  toDate: startOfTomorrow().toJSON(),
};

const reducers = {
  clearCascadingFilters(state) {
    return R.pipe(
      R.assoc('ptoNumber', ''),
      R.assoc('referenceId', ''),
      R.assoc('originator', ''),
      R.assoc('recipient', ''),
      R.assoc('location', ''),
      R.assoc('product', '')
    )(state);
  },
  resetFilters() {
    return initialState;
  },
  updateFilter: {
    prepare: (key, value) => ({
      payload: { key, value },
    }),
    reducer(state, { payload }) {
      return R.assoc(`${R.prop('key', payload)}`, R.prop('value', payload), state);
    },
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'searchPtoFilters',
  reducers,
});

const { updateFilter, clearCascadingFilters } = actions;
export const { resetFilters } = actions;

// Actions
export function updateSearchPtoFilter(key, value) {
  return dispatch => {
    dispatch(updateFilter(key, value));

    if (key === 'fromDate' || key === 'toDate' || key === 'status') {
      dispatch(clearCascadingFilters());
    }

    if ((key === 'fromDate' || key === 'toDate') && !parseISO(value)) {
      return;
    }
    dispatch(fetchSearchPTOs());
    dispatch(fetchOriginators());
    dispatch(fetchRecipients());
    dispatch(fetchLocations());
    dispatch(fetchPtoNumbers());
    dispatch(fetchReferenceIds());
    dispatch(fetchProducts());
  };
}

export function resetSearchPtoFilters(searchParams) {
  return dispatch => {
    dispatch(resetFilters());
    dispatch(fetchSearchPTOs(searchParams));
  };
}

export default reducer;
